<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-container>


      {{ $refs.infoPaciente }}

      <historiaNinoV2
        :edicionLinkUsuario="true"
        :idPacienteProp="idPaciente"
        :idClinicaProp="idClinica"
        ref="historia"
      />
    </b-container>
  </div>
</template>
<script>
import historiaNinoV2 from "./HistoriaNinoV2.vue";

export default {
  name: "HistoriaNinoLink",
  components: {
    historiaNinoV2,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    idPaciente: null,
    idClinica: null
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();

    let parametros = this.$route.params.idPaciente.split('/*')
    this.idPaciente = Number(this.$global.desencriptar(parametros[0]).replace(/"/g, ''));
    this.idClinica = Number(this.$global.desencriptar(parametros[1]).replace(/"/g, ''));
    if (this.idClinica === 0) {
      this.idClinica = null
    }
  },
};
</script>
